import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import "../../css/estudiantes.css";
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';
import BillingConceptForm from '../../components/Forms/BillingConceptForm';
import Swal from "sweetalert2";
import billingConceptService from '../../services/billingConceptService';
import utils from '../../utils/generalFunctions';
import useCustomDataTableStyles from '../../components/estilosDeDataTable';

const BillingConceptsView = () => {
  const [billingConcepts, setBillingConcepts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedConcept, setSelectedConcept] = useState(null);
  const [filterText, setFilterText] = useState('');
  const [BtnVer, setBtnVer] = useState('');

    const toggleModal = () => {
        setModalOpen(!modalOpen);
        setSelectedConcept(null);
    };

    const openMaximizeModal = (billingConcept) => {
        setSelectedConcept(billingConcept);
        setModalOpen(true);
        setBtnVer(true);
    };

    
    const openEditModal = (e, billingConcept) => {
        e.preventDefault();
        setSelectedConcept(billingConcept);
        setModalOpen(true);
        setBtnVer(false);
    };

    const deleteGrade = async (billingConcept) => {
      Swal.fire({
        title:  '¿Está seguro de que desea eliminar este concepto?',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar!'
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
          await billingConceptService.deleteBillingItem(billingConcept.billingConceptId);
          Swal.fire(
            'Felicidades!',
            'Concepto eliminado exitosamente!',
            'success'
          );
          await fetchBillingConcepts();
          }catch(error){
            Swal.fire(
                "Ha ocurrido un error",
                "Por favor intentelo más tarde",
                "error"
            );
          }
        }
      })
    };


  useEffect(() => {
    fetchBillingConcepts();
  }, []);

  const fetchBillingConcepts = async () => {
    try {
      const response = await billingConceptService.getAllBillingItems(); // Asumiendo que este servicio devuelve los conceptos de facturación
      setBillingConcepts(response);
    } catch (error) {
      console.error("Error al obtener los conceptos de facturación:", error);
    }
  };

  // Columnas para DataTable
  const columns = [
    { name: "Id", selector: "consecutive", sortable: true, 
    cell: (row, index) => <span>{index + 1}</span>,grow:"-2" },      
    { name: 'Descripción', selector: row => row.description, sortable: true,grow:"2.5"},
    { name: 'Valor', selector: row => row.value, format: row => `${utils.formatNumber.new(row.value, "$")}`, sortable: true },
    { name: 'Año', selector: row => row.year, sortable: true,grow:"-1" },
    { name: 'Nivel educativo', selector: row => row.educationLevelName, sortable: true,grow:"1.5" },
    { name: 'Jornada', selector: row => row.journeyName, sortable: true,grow:"1" },
    {
      name: 'Acciones',grow:"2.5",
      cell: (row) => (
         <div className="btn-group btn-group-sm">
                <button
                  onClick={() => openMaximizeModal(row)}
                  className="btn btn-outline-success me-1"
                  title="Maximizar información"
                >
                  <i className="fas fa-eye"></i>
                </button>
                <button
                  onClick={(e) => openEditModal(e, row)}
                  className="btn btn-outline-info me-1"
                  title="Editar"
                >
                  <i className="icon-edit fas fa-pencil-alt"></i>
                </button>
                <button
                  onClick={()=> deleteGrade(row)}
                  className="btn btn-outline-danger me-1"
                  title="Eliminar"
                >
                  <i className="icon-deactivate fas fa-times"></i>
                </button>
              </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  
  const normalizeString = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const filteredItems = billingConcepts?.filter((item) => {
    if (item) {
      const allData = `${item.name} ${item.abbreviation} ${item.order} ${item.journeyName} ${item.isActive}`;
      const normalizedFilterText = normalizeString(filterText);
      const normalizedItemName = normalizeString(allData);
      return normalizedItemName.includes(normalizedFilterText);
    }
    return item;
  });

  const customStyles = useCustomDataTableStyles();

  const paginationPerPage = 50; // Ajusta este número según tus necesidades

  return (
    <>
            <div className="col-md-12">

    <div className="card p-3">
    <div className="card-header">
        <h2 className="">Conceptos de pagos</h2>
        <h5 className="card-subtitle text-muted">Esta es la vista de configuración de conceptos de pagos.</h5>
      </div>
      <div className="card-body">

<form className="row mb-3">
<div className="col-md-6 col-xl-4 mb-2 mb-md-0">

                <input
                    type="text"
                    placeholder="Buscar"
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                    className="form-control "
                />
                </div>
                <div className="col-md-6 col-xl-8 ">

                    <div className="text-end">
                    <button className="btn btn btn-primary"  onClick={(e) => openEditModal(e, null)} >Agregar Nuevo Concepto <i className="fa-solid fa-circle-plus"></i></button>
                </div>
                </div>
                </form>
            </div>
      <DataTable
        columns={columns}
        data={filteredItems}
        pagination
        className="students-datatable shadow-sm rounded"     
        noDataComponent="No hay información que mostrar, por favor añadela"      
        fixedHeader
        fixedHeaderScrollHeight="450px"
        customStyles={customStyles}
        paginationPerPage={paginationPerPage} // Agrega esta propiedad para controlar las filas por página
        paginationRowsPerPageOptions={[50, 100]}

      />
            <>
            <MDBModal tabIndex='-1' show={modalOpen} setShow={setModalOpen}>
                <MDBModalDialog className="modal-dialog modal-md">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>CREACIÓN DE CONCEPTO DE PAGO</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleModal}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <div className='card'>
                                {selectedConcept && (
                                    <BillingConceptForm
                                        key={Date.now()}
                                        billingConceptId={selectedConcept.billingConceptId}
                                        onClose={() =>{
                                            setModalOpen(false); 
                                            fetchBillingConcepts();
                                        }}
                                        ReadOnly={BtnVer}
                                    />
                                )}

                                { !selectedConcept && (
                                    <BillingConceptForm
                                        key={Date.now()}
                                        billingConceptId={0}
                                        onClose={() =>{
                                            setModalOpen(false); 
                                            fetchBillingConcepts();
                                        }}
                                        ReadOnly={false}
                                    />
                                )}
                            </div>
                        </MDBModalBody>

                        <MDBModalFooter>
                        <button type='button' className='btn-footer-close btn-primary' onClick={toggleModal}>
                        Cerrar
                    </button>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            </>
    </div>
    </div>
    </>
  );
};

export default BillingConceptsView;